/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
  AchFileModelDto,
  AchPaymentDraftsDownloadModelDto,
  AchPaymentDraftsModelDto,
  ChannelUserActivityReportFilterDto,
  CompanyFiltersDto,
  DownloadPageDto,
  FilterUsersDto,
  GetBoReportFilterModelDto,
  ReportColumnModelBaseDto,
  ReportDataModelListUserActivityModelDto,
  ReportFilterBaseDto,
  ReportModelBaseDto,
  ReportSequenceDto,
  WireHistoryModelDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class ReportsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetReports
   * @summary Gets reports
   * @request GET:/reports
   */
  reportsGetReports = (params: RequestParams = {}) =>
    this.http.request<ReportModelBaseDto[], any>({
      path: `/reports`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetReportData
   * @summary Posts report data.
   * @request POST:/reports
   */
  reportsGetReportData = (
    data: ReportFilterBaseDto,
    params: RequestParams = {},
  ) =>
    this.http.request<any, any>({
      path: `/reports`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetReport
   * @summary Gets a report by id.
   * @request GET:/reports/report/{id}
   */
  reportsGetReport = (id: number, params: RequestParams = {}) =>
    this.http.request<ReportModelBaseDto, any>({
      path: `/reports/report/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetReportFilter
   * @summary Gets report filters.
   * @request GET:/reports/reportFilter
   */
  reportsGetReportFilter = (
    query?: {
      /** The filter type. */
      type?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ReportFilterBaseDto, any>({
      path: `/reports/reportFilter`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetReportFilterModel
   * @summary Gets the BO report filters model for the specified report ID.
   * @request GET:/reports/report/{id}/reportFiltersModel
   */
  reportsGetReportFilterModel = (id: number, params: RequestParams = {}) =>
    this.http.request<GetBoReportFilterModelDto, any>({
      path: `/reports/report/${id}/reportFiltersModel`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetReportCustomFilter
   * @summary Gets custom report filters.
   * @request GET:/reports/reportCustomFilter
   */
  reportsGetReportCustomFilter = (
    query?: {
      /** The report type */
      type?: string;
      /**
       * The id.
       * @format int32
       */
      id?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<any, any>({
      path: `/reports/reportCustomFilter`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsUpdateReportCustomFilter
   * @summary Updates custom report filters.
   * @request POST:/reports/reportCustomFilter
   */
  reportsUpdateReportCustomFilter = (
    data: ReportFilterBaseDto,
    params: RequestParams = {},
  ) =>
    this.http.request<any, any>({
      path: `/reports/reportCustomFilter`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetReportColumnModels
   * @summary Gets custom report columns.
   * @request GET:/reports/reportColumnModels
   */
  reportsGetReportColumnModels = (
    query?: {
      /** The type. */
      type?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ReportColumnModelBaseDto[], any>({
      path: `/reports/reportColumnModels`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsFavorite
   * @summary Gets favorites.
   * @request GET:/reports/favorite/{id}
   */
  reportsFavorite = (
    id: number,
    query?: {
      /** True or False */
      value?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ReportModelBaseDto, any>({
      path: `/reports/favorite/${id}`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsDeleteCustomReport
   * @summary Deletes custom reports.
   * @request GET:/reports/deletecustomreport/{id}
   */
  reportsDeleteCustomReport = (id: number, params: RequestParams = {}) =>
    this.http.request<boolean, any>({
      path: `/reports/deletecustomreport/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsUpdateSequence
   * @summary Updates sequences.
   * @request POST:/reports/updatesequence
   */
  reportsUpdateSequence = (
    data: ReportSequenceDto[],
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/reports/updatesequence`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetWireHistory
   * @summary Gets wire history report.
   * @request GET:/reports/getwirehistory/{id}
   */
  reportsGetWireHistory = (id: number, params: RequestParams = {}) =>
    this.http.request<WireHistoryModelDto[], any>({
      path: `/reports/getwirehistory/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetUserActivity
   * @summary Gets user activity.
   * @request POST:/reports/getUserActivity
   */
  reportsGetUserActivity = (
    data: ReportFilterBaseDto,
    params: RequestParams = {},
  ) =>
    this.http.request<ReportDataModelListUserActivityModelDto[], any>({
      path: `/reports/getUserActivity`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetChannelUserActivity
   * @summary Gets Channel user activities.
   * @request POST:/reports/ChannelUserActivity
   */
  reportsGetChannelUserActivity = (
    data: ChannelUserActivityReportFilterDto,
    params: RequestParams = {},
  ) =>
    this.http.request<ReportDataModelListUserActivityModelDto[], any>({
      path: `/reports/ChannelUserActivity`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetDownloadPageByReportType
   * @summary Gets download page by report type.
   * @request GET:/reports/GetDownloadPageByReportType
   */
  reportsGetDownloadPageByReportType = (
    query?: {
      /** The report type */
      reportType?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<DownloadPageDto, any>({
      path: `/reports/GetDownloadPageByReportType`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetProcessedByFilterUsers
   * @summary Retrieves the processed by filter users.
   * @request GET:/reports/achFileActivity/getProcessedByFilterUsers/{companyId}
   */
  reportsGetProcessedByFilterUsers = (
    companyId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<FilterUsersDto, any>({
      path: `/reports/achFileActivity/getProcessedByFilterUsers/${companyId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetUploadUserCompanies
   * @summary Retrieves the upload users' companies.
   * @request GET:/reports/achFileActivity/getUploadUserCompanies
   */
  reportsGetUploadUserCompanies = (params: RequestParams = {}) =>
    this.http.request<CompanyFiltersDto, any>({
      path: `/reports/achFileActivity/getUploadUserCompanies`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetUploadFilterUsers
   * @summary Retrieves the upload filter users.
   * @request GET:/reports/achFileActivity/getUploadFilterUsers/{companyId}
   */
  reportsGetUploadFilterUsers = (
    companyId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<FilterUsersDto, any>({
      path: `/reports/achFileActivity/getUploadFilterUsers/${companyId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetAchFileContent
   * @summary Retrieves the file content.
   * @request GET:/reports/achFileActivity/getAchFileContent/{fileArchiveId}
   */
  reportsGetAchFileContent = (
    fileArchiveId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<AchFileModelDto, any>({
      path: `/reports/achFileActivity/getAchFileContent/${fileArchiveId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetAchPaymentDrafts
   * @summary Retrieves the file content.
   * @request GET:/reports/achFileActivity/getAchPaymentDrafts/{achFileId}
   */
  reportsGetAchPaymentDrafts = (
    achFileId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<AchPaymentDraftsModelDto, any>({
      path: `/reports/achFileActivity/getAchPaymentDrafts/${achFileId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsDownloadAchPaymentDrafts
   * @summary Downloads the ACH payment drafts.
   * @request GET:/reports/achFileActivity/getAchPaymentDrafts/{achFileId}/download
   */
  reportsDownloadAchPaymentDrafts = (
    achFileId: number,
    query?: {
      /** The output type. */
      outputType?: string;
      /**
       * The value indicating whether is landscape mode or not.
       * @default false
       */
      isLandscape?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AchPaymentDraftsDownloadModelDto, any>({
      path: `/reports/achFileActivity/getAchPaymentDrafts/${achFileId}/download`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
}
